import { v4 as uuidv4 } from "uuid";

import { analytics } from "./analytics";
import {
  ANALYTICS_SCHEMA_VERSION,
  type AnalyticsEventName,
  EVENT_OWNER,
  type EventProperties,
  type ReservedEventProperties,
} from "./eventCatalogue";

export function captureEvent<TEvent extends AnalyticsEventName>(
  eventName: TEvent,
  properties: EventProperties<TEvent>,
): void {
  if (EVENT_OWNER[eventName] !== "posthog") {
    if (import.meta.env.DEV) {
      console.error(
        `[analytics] Refusing to send backend-owned event "${eventName}" from the frontend.`,
      );
    }

    return;
  }

  const reserved: ReservedEventProperties = {
    event_id: uuidv4(),
    schema_version: ANALYTICS_SCHEMA_VERSION,
  };

  analytics.capture(eventName, { ...properties, ...reserved });
}
